const groupByKeyAggregator = (key, transformation) => ((result, item) => {
  const keyValue = item[key];
  const values = result[keyValue] || [];
  const expectedTransformation = transformation;
  values.push(expectedTransformation(item));
  result[keyValue] = values; // eslint-disable-line no-param-reassign
  return result;
});

export default (array, key, transformation = (foo => foo)) =>
  (array.reduce(groupByKeyAggregator(key, transformation), {}));
